<app-page-header
  class="header"
  coreActivitySection="Header"
  coreUserActivityClickTracking="CloseMore"
  [backSwipe]="state() === 'main' ? backSwipeConfig : undefined"
  [routerLink]="['/main', 'home']"
/>

<div
  class="buttons"
  coreActivitySection="Buttons"
>
  <button
    class="button"
    [class.active]="state() === 'game'"
    coreUserActivityClickTracking="OpenGameOfTheMonth"
    (click)="state.set('game')"
  >
    <svg width="58" height="59" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" data-name="Glyph Icon">
      <path d="M23 39.3a16.2 16.2 0 0 0 10.8-4l4 4-.5.5a2 2 0 0 0 0 2.9l13.9 13.8a2 2 0 0 0 2.8 0l2.6-2.5a2 2 0 0 0 0-2.8l-14-13.9a2 2 0 0 0-2.7 0l-.6.6-4-4A16.2 16.2 0 1 0 23 39.2zm-8.4-24.7a12 12 0 1 1 0 17 12 12 0 0 1 0-17z"/>
    </svg>
    <div class="content">Game of the Month</div>
  </button>

  <button
    class="button"
    [class.active]="state() === 'events'"
    coreUserActivityClickTracking="OpenEvents"
    (click)="state.set('events')"
  >
    <svg class="icon" width="58" height="59" viewBox="0 0 58 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m9.696 38.174 4.083-12.249c1.85-5.553 2.776-8.33 4.967-8.847 2.19-.517 4.26 1.553 8.399 5.692l8.166 8.166c4.14 4.14 6.209 6.21 5.692 8.4-.517 2.19-3.294 3.115-8.848 4.966l-12.248 4.083c-6.684 2.228-10.025 3.342-11.789 1.578-1.764-1.764-.65-5.106 1.578-11.789Z"
        stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
      <path
        d="M29.568 44.42s-1.832-5.513-1.832-9.161c0-3.649 1.832-9.161 1.832-9.161m-10.077 21.07s-1.548-6.65-1.832-10.993C17.189 29 19.49 17.853 19.49 17.853M35.064 24.264l.348-1.74a4.992 4.992 0 0 1 3.316-3.757c1.7-.566 2.966-2 3.317-3.757l.348-1.74M42.459 32.112l.514.297a4.26 4.26 0 0 0 4.957-.502 4.26 4.26 0 0 1 4.533-.716l.704.308M23.672 6.8a3.385 3.385 0 0 0 .494 4.158l.237.237c.95.95 1.3 2.346.911 3.632"
        stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
      <path
        d="M16.742 9.606a1.296 1.296 0 1 1 1.833 1.833 1.296 1.296 0 0 1-1.833-1.833ZM29.38 17.38a1.296 1.296 0 1 1 1.833 1.832 1.296 1.296 0 0 1-1.833-1.832ZM41.463 24.63a1.296 1.296 0 1 1 1.833 1.832 1.296 1.296 0 0 1-1.833-1.832ZM46.057 37.09a1.296 1.296 0 1 1 1.834 1.834 1.296 1.296 0 0 1-1.834-1.833Z"
        fill="currentColor"/>
      <path
        d="M46.79 18.726c-1.62 1.62-.457 6.316-.457 6.316s4.696 1.162 6.316-.457c1.716-1.716.745-3.968-1.898-3.96.007-2.644-2.245-3.615-3.96-1.9Z"
        stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>
      <path
        d="m36.705 8.341-.067.235c-.073.258-.11.387-.092.513.017.127.086.237.225.456l.126.2c.488.774.732 1.16.566 1.476-.166.316-.633.353-1.565.426l-.241.018c-.265.021-.398.032-.514.092-.115.061-.202.166-.373.375l-.157.19c-.606.736-.909 1.104-1.254 1.056-.346-.047-.505-.478-.823-1.34l-.083-.223c-.09-.245-.135-.368-.224-.457-.09-.089-.212-.134-.457-.224l-.223-.083c-.862-.318-1.293-.478-1.34-.823-.047-.345.32-.648 1.056-1.254l.19-.156c.21-.173.314-.259.375-.374.06-.116.07-.249.092-.514l.018-.241c.073-.932.11-1.399.426-1.565.316-.166.702.078 1.476.566l.2.126c.22.139.33.208.456.225.126.018.255-.02.513-.092l.234-.067c.908-.258 1.361-.387 1.604-.144.243.243.114.696-.144 1.603Z"
        stroke="currentColor" stroke-width="3"/>
    </svg>
    <div class="content">Events</div>
  </button>

  <button
    class="button"
    [class.active]="state() === 'shop-beer'"
    coreUserActivityClickTracking="OpenShopBeer"
    (click)="state.set('shop-beer')"
  >
    <svg class="icon" width="58" height="59" viewBox="0 0 58 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.79 25.201v27.73a3 3 0 0 0 3 3h26.89a3 3 0 0 0 3-3v-4.1M8.79 25.2c-.997-.74-2.99-3.261-2.99-7.433 0-5.213 5.98-9.318 9.634-8.098 1.483-4.586 4.762-7.1 9.302-7.1s9.413 2.996 9.967 7.1c3.876-.776 9.966.666 10.41 4.77.442 4.105-.554 8.875-3.434 10.761m-32.89 0c2.822 1.61 4.448 1.921 7.531 0v4.216c0 1.442 1.883 3.106 3.212 3.106M41.678 25.2v4.216m0-4.216c-.885.666-3.3 1.797-5.869.999-3.211-.999-3.986-2.552-4.54-3.883-.775 1.553-1.883 3.883-4.208 3.883-1.86 0-4.098-1.553-4.983-2.33v5.547c0 1.664-1.219 3.106-2.547 3.106M41.678 48.83c1.256-.74 4.253-2.507 6.202-3.66 2.436-1.443 4.319-2.996 4.319-7.1v-8.653c0-2.219-1.994-4.216-5.426-4.216-2.747 0-4.54 2.81-5.095 4.216m0 19.413V29.417m-22.148 3.106v14.089m12.736-15.42v15.42"
        stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div class="content">Shop Beer</div>
  </button>

  <button
    class="button"
    [class.active]="state() === 'gift-card'"
    coreUserActivityClickTracking="OpenGiftCard"
    (click)="state.set('gift-card')"
  >
    <svg class="icon" width="58" height="59" viewBox="0 0 58 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M53.167 29.416H4.833M29 5.249v48.333M31.416 29.416a9.667 9.667 0 0 0 9.667 9.667M26.583 29.416a9.667 9.667 0 0 1-9.666 9.667"
        stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
      <path
        d="M29 24.668c0-3.6 2.45-6.74 5.944-7.613 3.875-.968 7.386 2.542 6.417 6.418a7.847 7.847 0 0 1-7.612 5.943H29v-4.748ZM29 24.668c0-3.6-2.45-6.74-5.944-7.613-3.875-.968-7.386 2.542-6.417 6.418a7.847 7.847 0 0 0 7.612 5.943H29v-4.748Z"
        stroke="currentColor" stroke-width="3"/>
      <path
        d="M4.833 29.416c0-11.393 0-17.089 3.54-20.628C11.912 5.25 17.608 5.25 29 5.25s17.089 0 20.628 3.54c3.539 3.538 3.539 9.234 3.539 20.627 0 11.392 0 17.088-3.54 20.627-3.538 3.54-9.235 3.54-20.627 3.54s-17.088 0-20.627-3.54c-3.54-3.539-3.54-9.235-3.54-20.627Z"
        stroke="currentColor" stroke-width="3"/>
    </svg>
    <div class="content">Gift Card</div>
  </button>

  <button
    class="button"
    [class.active]="state() === 'reservations'"
    coreUserActivityClickTracking="OpenReservations"
    (click)="state.set('reservations')"
  >
    <svg class="icon" width="58" height="59" viewBox="0 0 58 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.833 29.583c0-9.113 0-13.67 2.832-16.502 2.831-2.831 7.388-2.831 16.502-2.831h9.666c9.114 0 13.671 0 16.503 2.831 2.83 2.832 2.83 7.389 2.83 16.502v4.834c0 9.114 0 13.67-2.83 16.502-2.832 2.831-7.389 2.831-16.502 2.831h-9.667c-9.114 0-13.67 0-16.502-2.831-2.832-2.832-2.832-7.388-2.832-16.502v-4.834Z"
        stroke="currentColor" stroke-width="3"/>
      <path d="M16.916 10.25V6.625M41.084 10.25V6.625" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
      <circle cx="39.875" cy="40.458" r="3.625" stroke="currentColor" stroke-width="3"/>
      <path d="M6.042 22.333h45.916" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
    </svg>
    <div class="content">Reservations</div>
  </button>

  <button
    class="button"
    [class.active]="state() === 'rewards'"
    coreUserActivityClickTracking="OpenRewards"
    (click)="state.set('rewards')"
  >
    <svg class="icon" width="58" height="59" viewBox="0 0 58 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29 39.416c-13.92 0-16.385-13.872-16.822-24.876-.122-3.06-.183-4.59.967-6.007 1.15-1.416 2.526-1.648 5.278-2.112 2.716-.458 6.267-.838 10.577-.838s7.862.38 10.578.838c2.752.464 4.128.696 5.278 2.112 1.15 1.416 1.088 2.947.967 6.007C45.386 25.544 42.92 39.416 29 39.416Z"
        stroke="currentColor" stroke-width="3"/>
      <path
        d="m45.916 12.833 2.293.764c2.393.798 3.589 1.197 4.273 2.146.684.95.684 2.21.684 4.732v.176c0 2.08 0 3.12-.5 3.97-.501.852-1.41 1.357-3.229 2.367l-7.145 3.97M12.083 12.833l-2.292.764c-2.393.798-3.59 1.197-4.273 2.146-.685.95-.685 2.21-.684 4.732v.176c0 2.08 0 3.12.5 3.97.501.852 1.41 1.357 3.229 2.367l7.145 3.97"
        stroke="currentColor" stroke-width="3"/>
      <path d="M29 41.833v4.833" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
      <path
        d="M37.458 53.917H20.542l.82-4.1a2.417 2.417 0 0 1 2.369-1.942h10.538c1.152 0 2.144.813 2.37 1.943l.82 4.099Z"
        stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M43.5 53.917h-29" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
    </svg>
    <div class="content">Rewards</div>
  </button>

  <button
    class="button"
    [class.active]="state() === 'promos'"
    coreUserActivityClickTracking="OpenPromos"
    (click)="state.set('promos')"
  >
    <svg width="64" height="63" viewBox="0 0 64 63" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.912 42.36c-4.057-4.058-6.085-6.086-6.84-8.718-.755-2.632-.11-5.427 1.18-11.018l.744-3.224c1.086-4.703 1.628-7.055 3.239-8.665 1.61-1.61 3.962-2.153 8.665-3.239l3.224-.744c5.59-1.29 8.386-1.935 11.018-1.18 2.632.755 4.66 2.783 8.717 6.84l4.803 4.803C54.721 24.274 58.25 27.803 58.25 32.19c0 4.385-3.53 7.914-10.588 14.973C40.603 54.221 37.074 57.75 32.69 57.75c-4.386 0-7.915-3.53-14.974-10.588l-4.803-4.803Z"
        stroke="currentColor" stroke-width="3"
      />
      <circle cx="23.094" cy="23.308" r="5.25" transform="rotate(-45 23.094 23.308)" stroke="currentColor" stroke-width="3"/>
      <path d="m30.797 48.562 18.32-18.32" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
    </svg>
    <div class="content">Promos</div>
  </button>
</div>

@switch (state()) {
  @case ('game') {
    <app-more-game
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
  @case ('promos') {
    <app-promos
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
  @case ('events') {
    <app-more-events
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
  @case ('shop-beer') {
    <app-more-shop-beer
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
  @case ('gift-card') {
    <app-more-gift-card
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
  @case ('reservations') {
    <app-more-reservation
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
  @case ('rewards') {
    <app-more-rewards
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
}
